import SvgIcon from '@mui/material/SvgIcon'

const CaratUp = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
  </SvgIcon>
)
export default CaratUp
